<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.domain = Endpoints.domain;
        payload.filters.company = payload.$session.get('user').companyUser.company._id;

        await payload.filter();
    },
    methods:{
         filter: async function(){
            let state = this;
            state.items = [];
            
            setTimeout(async function(){
              let trucker = (await Request.do(state, 'POST', Request.getDefaultHeader(state),state.filters,`${Endpoints.systemUsers.filter}`));
                if (trucker.status==200){
                    state.items = trucker.data.results;
                }
            }, 100);
        },
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            copy.password = null;
            if(copy.customerUser.company)
                copy.customerUser.company = copy.customerUser.company._id;
            this.$emit('load-item', copy);
        }, 
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },

        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>